import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { DataConnectorMapping } from 'src/app/domainObjects/dataConnectorMapping';
import { DataTransformerConfig } from 'src/app/domainObjects/dataTransformConfig';
import { ConfigService } from 'src/app/services/config/config.service';
import { ConfigViewModelService } from 'src/app/services/configViewModel/config-view-model.service';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { DataFarmViewModel } from 'src/app/viewModels/dataFarmViewModel';
import { ImportDataViewModel } from 'src/app/viewModels/importDataViewModel';
import { PreviewTableComponent, ColumnInfo } from '../../../preview-table/preview-table.component';
import { BaseTransformerUIComponent, PriorityStringType, PriorityStringTypeUtil } from 'src/app/views/dataTransformConfig/transformers/base/base-transformer-ui/base-transformer-ui.component';
import { TransformPipelineService } from '../../../../services/transformPipeline/transform-pipeline.service';
import { DataDictionaryService } from 'src/app/services/dataDictionary/data-dictionary.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { FormBuilder, FormGroup, UntypedFormControl } from '@angular/forms';
import { ColoredTextItem } from 'src/app/domainObjects/coloredTextItem';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { TransformRuleViewModel } from 'src/app/viewModels/transformRuleViewModel';
import { UserDataService } from 'src/app/services/user-data-service';
import { RefineryPresenceService } from 'src/app/services/refinery-presence.service';
import { ComponentCanDeactivate } from 'src/app/guards/pending-changes.guard';
import { TransformType, TransformTypeUtil } from 'src/app/domainObjects/transformType';
import { ParameterSetting } from 'src/app/domainObjects/masterConfig';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { InputPrvwFilterViewModel } from 'src/app/viewModels/inputPrvwFilterViewModel';
import { SaveCurrntTransfrmcacheRequest } from 'src/app/messaging/saveCurrntTransfrmcacheRequest';
import { DataFarmTypeUtil } from 'src/app/domainObjects/dataFarmType';
import { EventNamerTransformRule } from 'src/app/domainObjects/transformers/eventNamerTransform';
import { EventNamerRuleViewModel } from './eventNamerRuleViewModel';
import { EventNamerViewModel } from './eventNamerViewModel';
import { collectDistinctSourceFields } from 'src/app/views/shared/utils/source-field.util';

@Component({
    selector: 'app-event-namer-transform-detail',
    templateUrl: './event-namer-transform-detail.component.html',
    styleUrls: ['./event-namer-transform-detail.component.css'],
    standalone: false
})
export class EventNamerTransformDetailComponent extends BaseTransformerUIComponent<EventNamerViewModel> implements OnInit,ComponentCanDeactivate {

  /** Distinct fields referenced by this config's rules, Default Source Field first — Smart Sample dropdown. */
  get eventNamerAvailableSourceFields(): string[] {
    const defaultField = this.viewModel?.parameters?.sourceColumn;
    const fromRules = collectDistinctSourceFields(this.viewModel?.rules, r => r.sourceColumn);
    if (!defaultField) return fromRules;
    return [defaultField, ...fromRules.filter(f => f !== defaultField)];
  }

  selectedIndex: number = 0;
  isResultsPanelExpanded = false;
  isPreviewPanelExpanded = false;    
  transformerInputPreviewCacheKey = "";
  dataSource: MatTableDataSource<EventNamerRuleViewModel> | undefined;
  PriorityStringType = PriorityStringType;
  PriorityStringTypeUtil = PriorityStringTypeUtil;

  PriorityStringTypes = [
    PriorityStringType.action,
    PriorityStringType.object
  ];
  
  displayedColumns: string[] = [
    'actions',
    'index',
    'name',
    'sourceField',
    'targetField',
    'actionString',
    'objectString',
    'priorityString',
    'includeAction',
    'ignoreSpaces',
    'matchCase',
    'isEnabled',
    'sampleHits',
    'hits'];

  isRuleSetEmpty = true;
  isRuleExecuting = false;

  updateDataSource: any;

  previewDataViewModel = new ImportDataViewModel();
  inputPrvwFilterViewModel = new InputPrvwFilterViewModel();
  
  isRulesMaximized = false;

  sortCtrl = new UntypedFormControl('');
  form: FormGroup;

  constructor(
    activeRoute: ActivatedRoute,
    errorService: ErrorReportingService,
    matDialog: MatDialog,
    snackBar: MatSnackBar,
    router: Router,
    configViewModelService: ConfigViewModelService,
    configService: ConfigService,
    navService: NavigationService,
    transformPipelineService: TransformPipelineService,
    userData: UserDataService,
    dataDictService: DataDictionaryService,
    refineryPresence: RefineryPresenceService,
    private cdRef: ChangeDetectorRef,private fb: FormBuilder) {

    super(activeRoute, errorService, matDialog, snackBar, router, configViewModelService, configService, navService, transformPipelineService, userData,dataDictService, refineryPresence);
    this.transformType = TransformType.eventNamer;
  }
  //other parameters

  //advanced settings parameters
  searchWildCard: ParameterSetting=new ParameterSetting();
  threads: ParameterSetting=new ParameterSetting();
  multiTargetColumn: ParameterSetting=new ParameterSetting();
  spaceSeparator: ParameterSetting=new ParameterSetting();
  removeRedundant: ParameterSetting=new ParameterSetting();
  transformType:TransformType;

   options: string[] =[];

   defaultSourceColumn='Source Field';
    defaultTargeteColumn='Target Field';

  ngOnInit(): void {
    super.ngOnInit();
    this.userData.setInputTabClicked(false);
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(false);
    this.resetInputPrvwViewModel();
    this.transformerInputPreviewCacheKey = "";
//validation
    this.form = this.fb.group({
      searchWildCard: ['', []],
      threads: ['', []]
    });
    this.registerFormGroup(this.form);

    this.totalRulesColumnDisplay();
  }

  protected override async onRouteActivated(_routeParams: any): Promise<void> {
    this.viewModel = new EventNamerViewModel(
      this.dataDictService,
      this.configService,
      this.dataTransformConfigViewModel,
      this.transformViewModel);
    this.viewModel.farmType=this.userData.getSelectedNodeDetails().farmtypeid;
    this.configureTargetColumnsFarmtypeid(this.userData.getSelectedNodeDetails().farmtypeid);
    this.snapshotPreState();

    this.dataSource = new MatTableDataSource<EventNamerRuleViewModel>(this.viewModel.rules);
    this.isRuleSetEmpty = this.viewModel.rules.length === 0;

    if (this.previewTable) { this.previewTable.clear(); }
    if (this.outputDataFarmPreviewTable) { this.outputDataFarmPreviewTable.clear(); }

    await this.setTransformerDetails(this.transformType);
    await this.downloadInputDataAsync();
    this.viewModel.parameters.sourceColumns=this.viewModel.sourceColumns;
    this.options=[...this.viewModel.sourceColumns.map(col => col.text).sort((a, b) => a.localeCompare(b))];
    this.viewModel.parameters.targetColumns=this.viewModel.targetColumns;
    await this.setDefaultValues(this.transformType);
    await this.removeInvalidValues();
  }
  onTransformTextChanged(){
    this.viewModel.transformViewModel.name=this.viewModel.transform.name;
    var currenttransform=this.dataTransformConfigViewModel.transforms.find(x=>x.guid==this.viewModel.transform.guid);
    currenttransform.name=this.viewModel.transform.name;
    currenttransform.transform.name=this.viewModel.transform.name;
    var vartransform=this.transformslists.find(x=>x.guid==this.viewModel.transform.guid);
    vartransform.name=this.viewModel.transform.name;
  }
  dropTable(event: CdkDragDrop<MatTableDataSource<TransformRuleViewModel>>): void {
    const prevIndex = event.previousIndex;
    const currentItem: EventNamerRuleViewModel = event.item.data;
    currentItem.index = prevIndex;
    moveItemInArray(this.viewModel.rules, prevIndex, event.currentIndex);
    this.viewModel.reindexRules();
    this.dataSource.data = this.viewModel.rules;
  }

  onRunChanged(event: MatSlideToggleChange): void {
    this.viewModel.rules.forEach( r => r.run = event.checked);
  }

  toggleRulesHeight(): void {
    this.isRulesMaximized = !this.isRulesMaximized;
  }

  compareDataFarm(o1: DataFarmViewModel, o2: DataFarmViewModel): boolean {
    return o1.name === o2.name && o1.id === o2.id;
  }
  
  onDeleteRule(rule: EventNamerRuleViewModel): void {
    this.showConfirmDialog('Delete Confirmation', `Are you sure you want to delete this rule?`, (confirmed) => {
      if (confirmed) {
        const index = this.viewModel.rules.indexOf(rule);
        this.viewModel.rules.splice(index, 1);
        this.viewModel.reindexRules();
        
        if ( this.viewModel.rules.length > 0 ) {
          const lastIndex = this.viewModel.rules.length - 1;
          //this.viewModel.selectedIngestConfig = this.viewModel.importDataViewModel.ingestConfigs[lastIndex];
        }
        else {
          //this.viewModel.selectedIngestConfig = null;
        }
        this.dataSource.data = this.viewModel.rules;
        this.isRuleSetEmpty = this.viewModel.rules.length === 0;
        //update rule table height
        if(this.viewModel.rules.length<=10){
          this.minrowcount=this.viewModel.rules.length;
        }else{
          this.minrowcount=10;
        }
        this.maxrowcount=this.viewModel.rules.length;
      }
    });
  }

  onDuplicateRule(sourceRule: EventNamerRuleViewModel): void {
    
    const vm = new EventNamerRuleViewModel(new EventNamerTransformRule());
    Object.assign(vm, sourceRule);
    
    this.viewModel.rules.splice(sourceRule.index, 0, vm);
    this.viewModel.reindexRules();
    this.dataSource.data = this.viewModel.rules;

    //console.log(`rule inserted at index: ${sourceRule.index}`);
    //update rule table height
    if(this.viewModel.rules.length<=10){
      this.minrowcount=this.viewModel.rules.length;
    }else{
      this.minrowcount=10;
    }
    this.maxrowcount=this.viewModel.rules.length;
    if(vm.index==this.maxrowcount){this.isScrollBottom=true; }else{this.isScrollBottom=false;}
  }
  minrowcount:number=10;
  maxrowcount:number=100;
  isScrollBottom:boolean=true;
  addNewRule(): void {
    var isValidDefaultParam=true;
    const selectedNode=this.userData.getSelectedNodeDetails();
    const masterconfig=this.userData.getMasterTransformers().find(x=>x.id==this.transformType);
    var params=masterconfig.parameters.find(x=>x.farmtypeid==selectedNode.farmtypeid).parameters.filter(n=>n.isruledefault==true);
    params.forEach(field => {
      if(field.jsonobject=="defSourceField"){
        if(!this.viewModel.parameters.sourceColumn){
          isValidDefaultParam=false;
        }
      }
      else if(field.jsonobject=="defTargetField"){
        if(!this.viewModel.parameters.targetColumn){
          isValidDefaultParam=false;
        }
      }
      else if(field.jsonobject=="userIdField"){
        if(!this.viewModel.parameters.userColumn){
          isValidDefaultParam=false;
        }
      }
      else if(field.jsonobject=="timestampField"){
        if(!this.viewModel.parameters.timeColumn){
          isValidDefaultParam=false;
        }
      }
    });

    if (!isValidDefaultParam) {
      this.displayError("Cannot add Rule unless Default field(s) are entered.","Please fix the validation error.");
      return;
    }
    const id = this.viewModel.rules.length;
    const rule = new EventNamerTransformRule();
    rule.ruleId = id;
    rule.index = id;
    rule.sourceField = this.viewModel.parameters.sourceColumn;
    rule.targetField = this.viewModel.parameters.targetColumn;
    rule.includeAction=true;
    if (!rule.priorityString && this.PriorityStringTypes.length > 0) {
      rule.priorityString = this.PriorityStringTypes[0];
    }
    const vm = new EventNamerRuleViewModel(rule);

    this.viewModel.rules.push(vm);
    this.isRuleSetEmpty = this.viewModel.rules.length === 0;
    this.dataSource.data = this.viewModel.rules;

    //update rule table height
    if(this.viewModel.rules.length<=10){
      this.minrowcount=this.viewModel.rules.length;
    }else{
      this.minrowcount=10;
    }
    this.maxrowcount=this.viewModel.rules.length;
  }

  getClassForRow(sender: PreviewTableComponent, row: any, colInfo: ColumnInfo, colInfos: ColumnInfo[]): string {
    try {
      return this.getClassForRowBase(sender, row, colInfo, colInfos);
    } catch (err) {
      return null;
    }
  }


  onColoredTextCellClicked(fieldName: string, rule: EventNamerRuleViewModel): void {
    let title: string=`Contains Editor Rule ${rule.index}`;
    let label: string="Enter Value";
    let placeholder: string="Enter Value";
    let fieldType: string ="edit";
    let isDuplicateRemoved: boolean =false;
    let canAddNewAutocomplete: boolean =false;
    let options: string[] = [];
    let dialogWidth: string='400px'
    if (fieldName === 'actionString') {
      title=`Action String Editor Rule ${rule.index}`;
      label="Action";
      if(!rule.actionString){
        rule.actionString=[];
      }
      this.showTextEditorDialogOption(title, label,placeholder,fieldType,isDuplicateRemoved,canAddNewAutocomplete,options,dialogWidth, 
        rule.actionString, 
        async (items: ColoredTextItem[],eventname:string) => {
          if(eventname=='save'){
            rule.actionString = items;
          }
        });
    } else if (fieldName === 'objectString') {
      title=`Object String Editor Rule ${rule.index}`;
      label="Object";
      if(!rule.objectString){
        rule.objectString=[];
      }
      this.showTextEditorDialogOption(title, label,placeholder,fieldType,isDuplicateRemoved,canAddNewAutocomplete,options,dialogWidth, 
        rule.objectString, 
        async (items: ColoredTextItem[],eventname:string) => {
          if(eventname=='save'){
            rule.objectString = items;
          }
        });
    }
  }

  saveConfig(): void {
    if (!this.validate()) {
      return;
    }

    //console.log(this.dataTransformConfigViewModel);

    if (this.dataTransformConfigViewModel.dataTransformerConfig?.id || this.dataTransformConfigViewModel.dataTransformerConfig?.guid) {
      //console.log('updating...');
      this.saveConfigImpl(this.dataTransformConfigViewModel.dataTransformerConfig.name);
    } else {
      //console.log('saving...');
      this.showSaveConfigDialog(async (configName: string) => {
        this.saveConfigImpl(configName);
      });
    }
  }

  async saveConfigImpl(configName: string): Promise<void> {
     var currenttransformer_sampleStart = this.viewModel.parameters.sampleStart ;
      var currenttransformer_sampleEnd = this.viewModel.parameters.sampleEnd  ;
    
        if (currenttransformer_sampleStart >=  currenttransformer_sampleEnd) {
            this.displayWarning(
              'Sample Start was greater than to Sample End, so it was auto-reset to 1.',
              'Warning',
              undefined,
              () => {
                this.viewModel.parameters.sampleStart = 1;
              }
            );
            return;
          }
          if(currenttransformer_sampleStart > this.totalInputRows || currenttransformer_sampleEnd > this.totalInputRows )
        {
    
          this.displayWarning(
            'Sample Range exceeded the Input Farm size and was auto-corrected to the maximum limit.',
            'Warning',
            undefined,  // no exception to pass
            () => {
           
              if (currenttransformer_sampleStart > this.totalInputRows) {
              this.viewModel.parameters.sampleStart = 1;
              }
              if (currenttransformer_sampleEnd > this.totalInputRows) {
                this.viewModel.parameters.sampleEnd = this.totalInputRows;
              }
            }
          );
          return;
        }
    const busyIndicator = this.showBusyDialog('Please wait...');
    try {
      let config = this.dataTransformConfigViewModel.dataTransformerConfig ?? new DataTransformerConfig();

      config.name = configName;
      config.organizationId = 1;
      config.dataSourceType = this.dataTransformConfigViewModel.dataSourceType;
      config.selectedIngestFarmGuid = this.dataTransformConfigViewModel.selectedIngestFarmGuid;
      
      // Save the Data Connectors
      config.dataConnectorMappings = this.dataTransformConfigViewModel.ingestConfigs
      .map ( ingestConfig =>
        new DataConnectorMapping(
          ingestConfig.id,
          ingestConfig.name,
          ingestConfig.targetDataFarm,
          ingestConfig.dataConnector.toDataConnector(),
          ingestConfig.columnMap
            .map(i => i.toColumnMapDefinition()),
          ingestConfig.guid,
          ingestConfig.masterColumnMapGuid)
      );

      //console.log('saving config...');
      //console.log(this.dataTransformConfigViewModel);

      // Save Transforms
      config.transforms = this.dataTransformConfigViewModel.transforms.map(t => t.transform);

      // Save the transform
      //const transform = config.transforms.find(t => t.id === this.viewModel.transform?.id) ?? this.viewModel.transformViewModel.transform;
      const transform = this.viewModel.transformViewModel.transform;
      //console.log(transform);

      transform.transformConfig = this.viewModel.toTransformConfig();
      // transform.dataFarmName = this.viewModel.dataFarm.name;
      // transform.dataFarmType = this.viewModel.dataFarm.dataFarmType;

      // TODO: Maintain list of transforms for this config
      const existingTransform = config.transforms.find(t => t.guid === transform.guid);
      if (existingTransform) {
        config.transforms.splice(config.transforms.indexOf(existingTransform), 1);
      }
      config.transforms.push(transform);
      

      // Save the ingest transforms
      //console.log(JSON.stringify(config));

      config = await this.configService.upsertConfig(config);
      //console.log(config);
      this.userData.setSelectedConfigJson(config);
      this.configViewModelService.setDataTransformConfigViewModel(new DataTransformConfigViewModel(config));
      this.userData.setSelectedTransform(this.dataTransformConfigViewModel.transforms.find(x=>x.guid=== this.userData.getSelectedTransform().guid));
      //update preViewModel
      this.snapshotPreState();

      // SAve the current node status to Not RunConfigRequest.
      const selectedNode = this.userData.getSelectedNodeDetails();
      //const RefineryConfigJson = await this.configService.getRefineryConfigByGuidAsync(selectedNode.refineryConfigGuid);
      // //console.log('Refinery json in save = ', RefineryConfigJson) ;
      //RefineryConfigJson.nodes.filter(newNode => newNode.id == selectedNode.id)[0].data.nodeStatus = NodeRunStatus.NotRun
      //let RefineryJson = await this.configService.UpsertRefineryConfig(RefineryConfigJson);
      
      // var UpdateNodesStatus: UpdateNodesStatusRequest = new UpdateNodesStatusRequest(selectedNode.refineryConfigGuid, selectedNode.id, NodeRunStatus.PipelineModified )
      // let updateStatusreturn = await this.configService.updateUpcomingNodesStatus(UpdateNodesStatus);
      
      //Invoke the save current transformer cache api
       const activeTransformGuid = this.userData.getSelectedTransform().guid
       const userId = this.userData.getUserId()
       const orgId = this.userData.getOrgId()
       var saveCurrentTransformerCacheRequest: SaveCurrntTransfrmcacheRequest = new SaveCurrntTransfrmcacheRequest(userId, orgId, selectedNode.id, selectedNode.refineryConfigGuid, this.dataTransformConfigViewModel.selectedIngestFarmGuid, activeTransformGuid);
       await this.configService.saveCurrentTransformerCache(saveCurrentTransformerCacheRequest);
       await this.configService.getRefineryConfigByGuidAsync(this.userData.getRefineryId());
       this.getCacheStatus();
       // this.cdRef.detectChanges();
      this.snackBar.open(`Successfully saved transform pipeline '${this.userData.getSelectedTransform().name}'`, 'Dismiss', {
        duration: 5000
      });
      busyIndicator.close();

    } catch (err) {
      busyIndicator.close();
      this.displayError(`Failed to save '${this.userData.getSelectedTransform().name}'`, 'Error', err);
    }
  }
  
  onSetDefaultRule(defaultfield:string){
    if(defaultfield=="sourceColumn"){
      this.viewModel.rules.forEach(rule=>{
        rule.sourceColumn=this.viewModel.parameters.sourceColumn;
      })
    }
    else if(defaultfield=="targetColumn"){
      this.viewModel.rules.forEach(rule=>{
        rule.targetColumn=this.viewModel.parameters.targetColumn;
      })
    }
  }
  totalRulesColumnDisplay(){
    //blank values
    this.viewModel.rules.forEach(rule=>{
      rule.hits=null;
    })
    if(this.viewModel.parameters.runAll){
      this.displayedColumns= [
        'actions',
        'index',
        'name',
        'sourceField',
        'targetField',
        'actionString',
        'objectString',
        'priorityString',
        'includeAction',
        'ignoreSpaces',
        'matchCase',
        'isEnabled',
        'sampleHits',
        'hits'];
      }else{
      this.displayedColumns= [
        'actions',
        'index',
        'name',
        'sourceField',
        'targetField',
        'actionString',
        'objectString',
        'priorityString',
        'includeAction',
        'ignoreSpaces',
        'matchCase',
        'isEnabled',
        'sampleHits'];
    }
    this.cdRef.detectChanges();
  }
  onToggleRulesColumnDisplay(){
    this.totalRulesColumnDisplay();
  }
  onToggleMultiTarget(event: any){
    this.viewModel.multiTargetColumn=event.checked;
  }
  onToggleSpaceSeparator(event: any){
    this.viewModel.spaceSeparator=event.checked;
  }
  onToggleRemoveRedundant(event: any){
    this.viewModel.removeRedundant=event.checked;
  }
  onParameterFormStatusChange(status: boolean) {
    this.isParameterFormValid = status;
  }

  onTabClick(event: MatTabChangeEvent): void {
    const selectedTabIndex = event.index;
    const selectedTabLabel = event.tab.textLabel;
    this.selectedIndex = selectedTabIndex;
 
    // Alert the tab index and label
   // alert(`Tab clicked: ${selectedTabLabel} (Index: ${selectedTabIndex})`);
   this.userData.setResultsTabClicked(false);
   if(selectedTabLabel.match("Output") && selectedTabIndex == 1) {
    this.userData.setOutputTabClicked(true)
    this.setOutputPreviewTabSlctnStatus();
   } else {
      this.userData.setOutputTabClicked(false);
      this.setInputPreviewFilterViewModel();
      //  if(selectedTabLabel.match("Summary") && selectedTabIndex == 2) {
      //     if(this.source.length > 0) {
      //       let selectFilterInfoSummary = new SelectFilterInfo(this.source, this.selectFilterValues);
      //       this.onApplySelect(selectFilterInfoSummary);
      //     }
      //   }
   }
  }

  setInputPreviewFilterViewModel() {
    this.inputPrvwFilterViewModel.previewType = "TransformerInput";
    this.setTransformerInputPrvwCacheKey();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel)
  }

  resetInputPrvwViewModel() {
    this.inputPrvwFilterViewModel.farmId = "";
    this.inputPrvwFilterViewModel.collookupFarmId = "";
    this.inputPrvwFilterViewModel.nodeType = "";
    this.inputPrvwFilterViewModel.previewType = "TransformerInput";
    this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = "";
  }

  setSubTaskResultsTabClicked(): void {
    if(this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey.length > 0) {
      this.transformerInputPreviewCacheKey = this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey;
    }
    
    this.userData.setOutputTabClicked(false);
    this.userData.setResultsTabClicked(true);
    this.resetTransformerInputPrvwModelData();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
    this.isResultsPanelExpanded = true;
    this.isPreviewPanelExpanded = false;
  }

  setSubTaskPreviewTabClicked(): void {
    if(this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey.length > 0) {
      this.transformerInputPreviewCacheKey = this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey;
    }
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(false);
    this.isResultsPanelExpanded = false;
    this.isPreviewPanelExpanded = true;
    if(this.selectedIndex == 0) {
      this.setInputPreviewFilterViewModel();
    }
    if(this.selectedIndex == 1) {
      this.setOutputPreviewTabSlctnStatus();
    }
  }

  setTransformerInputPrvwCacheKey() {
    if(this.transformerInputPreviewCacheKey.length > 0 && this.inputPrvwFilterViewModel.farmId.length > 0) {
      this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = this.transformerInputPreviewCacheKey;
      this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
    }
  }

  setOutputPreviewTabSlctnStatus(): void {
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(true);
    this.resetTransformerInputPrvwModelData();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
  }

  resetTransformerInputPrvwModelData() {
    this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = "";
    this.inputPrvwFilterViewModel.previewType = "";
  }
  
  get isValidateParameters(): boolean {
    return !this.isParameterFormValid;
  }
  get isValidateAdvanceSettings(): boolean {
    return this.form.invalid;
  }
  async setDefaultValues(transformType:TransformType): Promise<void>{
    const selectedNode=this.userData.getSelectedNodeDetails();
    const masterconfig=this.userData.getMasterTransformers().find(x=>x.id==transformType);
    var parameters=masterconfig.parameters.find(x=>x.farmtypeid==selectedNode.farmtypeid);
    if(parameters){
      var params=parameters.parameters;
      //other parameters
      //advanced settings parameters
      this.searchWildCard=params.find(x=>x.jsonobject=='searchWildCard');
      this.threads=params.find(x=>x.jsonobject=='threads');
      this.multiTargetColumn=params.find(x=>x.jsonobject=='multiTargetColumn');
      this.spaceSeparator=params.find(x=>x.jsonobject=='spaceSeparator');
      this.removeRedundant=params.find(x=>x.jsonobject=='removeRedundant');
      //check this is first this.viewModel.sampleEnd =0
      if((this.viewModel.sampleEnd-1)==0 || isNaN(this.viewModel.sampleEnd)){
        if(this.multiTargetColumn.default!=""){
          this.viewModel.multiTargetColumn=this.stringToBoolean(this.multiTargetColumn.default);
        }
        if(this.spaceSeparator.default!=""){
          this.viewModel.spaceSeparator=this.stringToBoolean(this.spaceSeparator.default);
        }
        if(this.removeRedundant.default!=""){
          this.viewModel.removeRedundant=this.stringToBoolean(this.removeRedundant.default);
        }
      //other parameters

      //advanced settings parameters
        if(this.searchWildCard.default!=""){
          this.viewModel.searchWildCard=this.searchWildCard.default;
        }
        if(this.threads.default!=""){
          this.viewModel.threads=Number(this.threads.default);
        }
      }
    }else{
      //advanced settings parameters
      // this.bufferRows.label="Buffer Rows";this.bufferRows.jsonobject="bufferRows";this.bufferRows.min=0;this.bufferRows.max=10000000;
      // this.threads.label="Threads (0 > Auto)";this.threads.jsonobject="threads";this.threads.min=0;this.threads.max=64;
      // this.resetRows.label="Reset Row Numbers";this.resetRows.jsonobject="resetRows";
    }
  }
  async removeInvalidValues(): Promise<void>{
    //other parameters
    //advanced settings parameters
  }
  async loadImportTransformer(transform: any): Promise<void>{
    const busyIndicator = this.showBusyDialog('Please wait...');
    try{
      if(this.userData.getSelectedNodeDetails().farmtypeid!=transform.farmType){
        this.displayError("Current DataFarmType is " + DataFarmTypeUtil.toString(this.userData.getSelectedNodeDetails().farmtypeid) + ". But you are trying to load a different DataFarmType: " + DataFarmTypeUtil.toString(transform.farmType),"Error");
        return;
      }else if(this.transformType!=transform.transformType){
        this.displayError("Current transform is " + TransformTypeUtil.toString(this.transformType) + ". But you are trying to load a different transform type: " + TransformTypeUtil.toString(transform.transformType),"Error");
        return;
      }
      var ctranformconfig=this.dataTransformConfigViewModel.transforms.find(x=>x.guid=== this.userData.getSelectedTransform().guid);
      ctranformconfig.transform.transformConfig=transform;
      var newmodel =new EventNamerViewModel(this.dataDictService,this.configService,this.dataTransformConfigViewModel,ctranformconfig);
      // force new object reference for UI refresh
      this.viewModel.rules=[];
      this.viewModel.rules=[...newmodel.rules];
      this.isRuleSetEmpty = this.viewModel.rules.length === 0;
      this.dataSource.data = this.viewModel.rules;
      //update Parameters
      this.viewModel.parameters.sourceColumn=newmodel.parameters.sourceColumn;
      this.viewModel.parameters.targetColumn=newmodel.parameters.targetColumn;
      this.viewModel.parameters.userColumn=newmodel.parameters.userColumn;
      this.viewModel.parameters.timeColumn=newmodel.parameters.timeColumn;
      this.viewModel.parameters.sortInfo=newmodel.parameters.sortInfo;
      this.viewModel.parameters.includeInResults=newmodel.parameters.includeInResults;
      this.viewModel.parameters.sampleStart =newmodel.parameters.sampleStart;
      this.viewModel.parameters.sampleEnd =newmodel.parameters.sampleEnd;
      this.viewModel.parameters.runAll =newmodel.parameters.runAll;
      this.viewModel.parameters.deleteMisses =newmodel.parameters.deleteMisses;
      this.viewModel.parameters.missName =newmodel.parameters.missName;
      //other parameters
      
      //advanced settings parameters
      this.viewModel.threads = newmodel.threads;
      this.viewModel.searchWildCard = newmodel.searchWildCard;
      this.viewModel.multiTargetColumn = newmodel.multiTargetColumn;
      this.viewModel.spaceSeparator = newmodel.spaceSeparator;
      this.viewModel.removeRedundant = newmodel.removeRedundant;
      //update rule table height
      if(this.viewModel.rules.length<=10){
        this.minrowcount=this.viewModel.rules.length;
      }else{
        this.minrowcount=10;
      }
      this.maxrowcount=this.viewModel.rules.length;
    }catch (err) {
      this.displayError(`Failed to save import transformer`, 'Error', err);
    }finally {
      busyIndicator.close();
    }
  }
}


